import React from 'react';
export const StickyCTA = () => {
  return <div className="fixed bottom-0 left-0 right-0 bg-green-600 hover:bg-green-700 text-white font-bold py-3 text-center shadow-lg transition-colors duration-200 z-50 text-sm sm:text-base" data-id="element-202">
      <a href="https://tryelivara.com/pages/elivara-landing-page" className="block w-full uppercase tracking-wider" data-id="element-203">
        GET 40% OFF ELIVARA LEGGINGS NOW!
      </a>
    </div>;
};